import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import qs from 'qs';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import Layout from 'components/common/Layout';
import QuickNavigation from 'components/home/QuickNavigation';
import StatsDoughnutChart from 'components/home/StatsDoughnutChart';
import StatsLineChart from 'components/home/StatsLineChart';
import EraChart from 'components/home/EraChart';
import Notifications from 'components/home/Notifications';
import BusinessGeneralDialog from 'components/settings/BusinessGeneralDialog';
import SignUpSuccessDialog from 'components/home/SignUpSuccessDialog';
import Button from 'components/common/Button';
import IconArrowHeadBottom from 'components/icons/IconArrowHeadBottom';

import { appTitle, titleSeparator } from 'config/helmetSettings';

import {
  setRouterParamsSignUpSuccess,
  removeRouterParamsSignUpSuccess,
  expandNotificationsDashboard,
  collapseNotificationsDashboard,
} from 'redux/modules/routerParams';

const styles = theme => ({
  notificationsContainer: {
    height: 230,
    marginBottom: 16,
    position: 'relative',
    zIndex: 1,
    transition: theme.transitions.create(['height'], {
      duration: theme.transitions.duration.short,
    }),
    [theme.breakpoints.down('sm')]: {
      height: 328,
      marginBottom: 8,
    },
  },
  notificationsContainerExpanded: {
    height: 630,
    '& $iconArrowHeadBottom': {
      transform: 'rotate(180deg)',
    },
  },
  lineChartContainer: {
    // height: 434,
    transition: theme.transitions.create(['height'], {
      duration: theme.transitions.duration.short,
    }),
  },
  button: {
    position: 'absolute',
    left: '50%',
    bottom: -15,
    marginLeft: -7,
    width: 30,
    height: 30,
    minHeight: 30,
    color: theme.palette.grey[600],
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  iconArrowHeadBottom: {
    width: 14,
    height: 14,
  },
});

class Index extends Component {
  constructor(props) {
    super(props);

    this.state = {
      signUpSuccessDialogOpen: false,
      businessGeneralDialogOpen: false,
    };

    this.onSignUpSuccessDialogClose = this.onSignUpSuccessDialogClose.bind(this);
    this.onSignUpSuccessDialogSubmit = this.onSignUpSuccessDialogSubmit.bind(this);
    this.onBusinessGeneralDialogClose = this.onBusinessGeneralDialogClose.bind(this);
    this.onNotificationsExpandCollapseButtonClick = this.onNotificationsExpandCollapseButtonClick.bind(this);
  }

  componentWillMount() {
    const { recoverOrder, loginRedirect, account, location, history, actions } = this.props;
    const params = qs.parse(location.search, { ignoreQueryPrefix: true });
    if (params.login) {
      if (recoverOrder[account.ID]) {
        const recoverHref = recoverOrder[account.ID].ID
          ? `/workflow/order/edit/${recoverOrder[account.ID].ID}`
          : `/workflow/order/create/patient/${recoverOrder[account.ID]['Patient ID']}`;
        history.replace(recoverHref);
      } else if (loginRedirect) {
        history.replace(loginRedirect);
      } else {
        history.replace('/');
      }
    } else if (params.signup) {
      actions.setRouterParamsSignUpSuccess();
      setTimeout(() => {
        history.replace('/');
      }, 500);
    }
  }

  componentDidMount() {
    const { actions } = this.props;
    setTimeout(() => {
      if (this.props.signUpSuccess) {
        actions.removeRouterParamsSignUpSuccess();
        this.setState({ signUpSuccessDialogOpen: true });
      }
    }, 700);
  }

  onSignUpSuccessDialogClose() {
    this.setState({ signUpSuccessDialogOpen: false });
  }

  onSignUpSuccessDialogSubmit() {
    this.setState({
      signUpSuccessDialogOpen: false,
      businessGeneralDialogOpen: true,
    });
  }

  onBusinessGeneralDialogClose() {
    this.setState({ businessGeneralDialogOpen: false });
  }

  onNotificationsExpandCollapseButtonClick() {
    if (this.props.notificationsDashboardExpanded) {
      this.props.actions.collapseNotificationsDashboard();
    } else {
      this.props.actions.expandNotificationsDashboard();
    }
  }

  render() {
    const { location, notificationsDashboardExpanded, classes } = this.props;
    const { signUpSuccessDialogOpen, businessGeneralDialogOpen } = this.state;
    const params = qs.parse(location.search, { ignoreQueryPrefix: true });
    if (params.login) {
      return '';
    }
    return (
      <Layout>
        <Helmet>
          <title>
            {appTitle} {titleSeparator} Home
          </title>
        </Helmet>
        <Grid
          container
          spacing={16}
          justify="flex-end"
        >
          <Grid
            item
            xs={12}
            sm={12}
            md={7}
          >
            <div className={classNames(classes.notificationsContainer,{
              [classes.notificationsContainerExpanded]: notificationsDashboardExpanded,
            })}>
              <Notifications
                expanded={notificationsDashboardExpanded}
              />
              <Button
                variant="fab"
                className={classes.button}
                onClick={this.onNotificationsExpandCollapseButtonClick}
              >
                <IconArrowHeadBottom
                  className={classes.iconArrowHeadBottom}
                />
              </Button>
            </div>
            <div className={classes.lineChartContainer}>
              <EraChart />
            </div>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={5}
          >
            <QuickNavigation />
            <StatsLineChart />
            <StatsDoughnutChart />
          </Grid>
        </Grid>
        <SignUpSuccessDialog
          open={signUpSuccessDialogOpen}
          onClose={this.onSignUpSuccessDialogClose}
          onSubmit={this.onSignUpSuccessDialogSubmit}
        />
        <BusinessGeneralDialog
          open={businessGeneralDialogOpen}
          onClose={this.onBusinessGeneralDialogClose}
        />
      </Layout>
    );
  }
}

Index.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  recoverOrder: PropTypes.object,
  loginRedirect: PropTypes.string,
  signUpSuccess: PropTypes.bool,
  account: PropTypes.shape({
    ID: PropTypes.number.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired,
  }).isRequired,
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
  actions: PropTypes.shape({
    setRouterParamsSignUpSuccess: PropTypes.func.isRequired,
    removeRouterParamsSignUpSuccess: PropTypes.func.isRequired,
  }).isRequired,
};

Index.defaultProps = {
  recoverOrder: {},
  loginRedirect: null,
  signUpSuccess: false,
};

const mapStateToProps = store => ({
  recoverOrder: store.recoverOrder,
  loginRedirect: store.routerParams.loginRedirect,
  signUpSuccess: store.routerParams.signUpSuccess,
  account: store.account,
  notificationsDashboardExpanded: store.routerParams.notificationsDashboardExpanded,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    setRouterParamsSignUpSuccess,
    removeRouterParamsSignUpSuccess,
    expandNotificationsDashboard,
    collapseNotificationsDashboard,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(Index)
);



// WEBPACK FOOTER //
// ./src/pages/home/Index.js